export default __webpack_public_path__ + "b8a5f51b167c84e3828b5d2a22e019c0.png";